import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { UserService } from '@ibc-features/user/services/users.service';
import { catchError, map, of } from 'rxjs';

export const confirmAccountResolver: ResolveFn<boolean> = (route: ActivatedRouteSnapshot) => {
  const user = inject(UserService);
  const token = route.queryParamMap.get('token') ?? '';
  const payload = {
    token: token,
  };
  if (!token) return of(false);
  return user.confirmAccount(payload).pipe(
    map(() => true),
    catchError(() => of(false))
  );
};
